import { LinkButton } from "../../../../atoms/link-button";
import * as React from "react";
import { RemovalTaskScheduled } from "@graffer-inc/cloud-gov-core";
import { useModal } from "../../../../../utils/custom-hooks";

import { RemovalTaskScheduledModal } from "../../../../organisms/smart-apply/modals/removal-task-scheduled-modal";
import { useAuthContextV2 } from "../../../../../auth-state";
import { Link } from "react-router-dom";
import { SmartApplyR } from "../../route";
import { useMemo } from "react";

export const RemovalTaskScheduledView: React.FC<{
  event: RemovalTaskScheduled;
}> = ({ event }) => {
  const modal = useModal();
  const authState = useAuthContextV2();
  const canReadApplicationRemovalTask = useMemo(() => {
    return authState.auth.checkGroupPermissionWithoutTarget([
      "applications.removal_tasks_read",
    ]);
  }, [authState]);

  return (
    <>
      <p className="has-text-weight-bold">
        {canReadApplicationRemovalTask ? (
          <Link
            to={SmartApplyR.ApplicationRemovalTaskDetail.link({
              id: event.data.taskId,
            })}
          >
            申請削除タスク
          </Link>
        ) : (
          "申請削除タスク"
        )}
        が作成されました。
      </p>
      {!canReadApplicationRemovalTask && (
        <p className="has-text-weight-normal mt-2">
          <LinkButton
            className="button is-rounded is-small"
            onClick={modal.open}
          >
            詳細を確認
          </LinkButton>
        </p>
      )}
      {modal.isActive && (
        <RemovalTaskScheduledModal event={event} onClose={modal.close} />
      )}
    </>
  );
};
